// URL examples:
// Address bar: https://www.youtube.com/watch?v=LXb3EKWsInQ
// Share: https://youtu.be/LXb3EKWsInQ?si=nljsk-piKltZKHHL
// Share + time: https://youtu.be/LXb3EKWsInQ?si=nljsk-piKltZKHHL&t=5
// Embed: https://www.youtube.com/embed/LXb3EKWsInQ?si=klBRTZ1UooxmCl9e
// Live:
// Address bar: https://www.youtube.com/live/rIFDqCYMOAQ
// Share: https://www.youtube.com/live/rIFDqCYMOAQ?si=4ZN7_XEIB7M97J1D
// const exampleUrls = [
//   "https://www.youtube.com/watch?v=LXb3EKWsInQ",
//   "https://youtu.be/LXb3EKWsInQ?si=nljsk-piKltZKHHL",
//   "https://youtu.be/LXb3EKWsInQ?si=nljsk-piKltZKHHL&t=5",
//   "https://www.youtube.com/embed/LXb3EKWsInQ?si=klBRTZ1UooxmCl9e",
//   "https://www.youtube.com/live/rIFDqCYMOAQ?si=4ZN7_XEIB7M97J1D",
// ];

export interface YouTubeUrlInfo {
  url: string;
  videoId: string;
}

export class YouTubeHelper {
  public static parseUrl(url: Nil<string>): YouTubeUrlInfo | null {
    if (!url || typeof url !== "string") {
      return null;
    }

    try {
      // Normalize URL (add protocol if missing)
      let normalizedUrl = url.trim();
      if (!normalizedUrl.startsWith("http://") && !normalizedUrl.startsWith("https://")) {
        normalizedUrl = "https://" + normalizedUrl;
      }

      const urlObj = new URL(normalizedUrl);

      let videoId: string | null = null;

      // 1. Standard watch URL: https://www.youtube.com/watch?v=VIDEO_ID
      if (urlObj.pathname === "/watch" || urlObj.pathname === "/watch/") {
        videoId = urlObj.searchParams.get("v");
      }
      // 2. Shortened youtu.be URL: https://youtu.be/VIDEO_ID
      else if (urlObj.hostname === "youtu.be" || urlObj.hostname === "www.youtu.be") {
        videoId = urlObj.pathname.slice(1); // remove leading '/'
      }
      // 3. Embed URL: https://www.youtube.com/embed/VIDEO_ID
      else if (urlObj.pathname.startsWith("/embed/")) {
        videoId = urlObj.pathname.split("/")[2];
      }
      // 4. Live URL: https://www.youtube.com/live/VIDEO_ID
      else if (urlObj.pathname.startsWith("/live/")) {
        videoId = urlObj.pathname.split("/")[2];
      }

      // Clean videoId (remove any extra params or invalid characters)
      if (videoId) {
        videoId = videoId.split("?")[0].split("&")[0].trim();
      }

      if (videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
        return {
          url: normalizedUrl,
          videoId: videoId,
        };
      }

      return null;
    } catch (err) {
      console.error("Error parsing YouTube URL:", err);
      return null;
    }
  }
}
